import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { UpdateSharedIpSettings } from '../../../../../store/actions/internet-settings.actions';
import { OnDestroyHookDirective } from '../../../../../shared/hooks';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getSharedIpState,
} from '../../../../../store/reducers';
import { Alert, AlertsService } from '@proximus/ng-common-components';

@Component({
  selector: 'mprd-shared-ip',
  templateUrl: './shared-ip.component.html',
})
export class SharedIpComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() loginId: string;

  sharedIpSuccess: boolean;
  sharedIpError: boolean;

  constructor(
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
    private store: Store<ApplicationState>,
    private alertService: AlertsService,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.initInception();
    this.addSubscription(
      this.store.select(getSharedIpState).subscribe((data) => {
        this.sharedIpError = data.error;
        this.sharedIpSuccess = data.success;
        this.dispatchAlert(this.sharedIpSuccess, this.sharedIpError);
      }),
    );
  }

  private initInception() {
    this.inceptionService.init();
  }

  updateIpSettings() {
    this.store.dispatch(new UpdateSharedIpSettings(this.loginId));
  }

  private dispatchAlert(
    updateSharedIpSuccess: boolean,
    updateSharedIpFailed: boolean,
  ): void {
    let title: string;
    let description: string;
    let type: 'error' | 'info' | 'success' | 'warning';
    let taggingData: any;

    if (updateSharedIpSuccess) {
      title = this.translationService.getTranslatedValueFor(
        'internet.settings.password.update.confirmation.label',
      );
      description = this.translationService.getTranslatedValueFor(
        'internet.settings.shared.ip.update.success',
      );
      type = 'success';
      taggingData = {
        event: 'popup-impression',
        button: {
          zone: this.translationService.getTranslatedValueFor(
            'internet.settings.shared.ip.title',
          ),
          name: 'change success',
        },
      };
    } else if (updateSharedIpFailed) {
      title = this.translationService.getTranslatedValueFor(
        'internet.settings.password.update.error.label',
      );
      description = this.translationService.getTranslatedValueFor(
        'internet.settings.shared.ip.update.failed',
      );
      type = 'error';
      taggingData = {
        event: 'popup-impression',
        button: {
          zone: this.translationService.getTranslatedValueFor(
            'internet.settings.shared.ip.title',
          ),
          name: 'change error',
        },
        error: {
          type: 'backend',
          message: description,
        },
      };
    }
    const alert: Alert = {
      isClosable: true,
      alertKey: 'updateSharedIpAlert',
      title,
      description,
      type,
      taggingData,
    };
    this.alertService.dispatchAlert(alert);
  }
}
